import {
    SET_SOLAR_SYSTEM_SIZE,
    SET_SOLAR_PRODUCTION_RATIO,
    SET_SOLAR_ANNUAL_DEG,
    SET_SYSTEM_PRICE,
    SET_SOLAR_VALUE,
    SET_INSTALL_TYPE,
    SET_INSTALL_TYPE2,
    SET_SOLAR_PANEL,
    SET_INVERTER,
    SET_SYSTEM_NOTES,
    SET_SOLAR_INPUTS,
} from './constants';

const defaultState = {
    annualDeg: 0.5,
    productionRatio: 1227,
    solarValue: 0,
    cashprice: 0,
    systemSize: 0,
    installType: 'pc',
    installType2: 'na',
    solarPanel: 'cs325bbb',
    inverter: 'solaredge',
    systemNotes: '',
};

const solar = (state = defaultState, action) => {
    switch (action.type) {
        case SET_SOLAR_INPUTS:
            return {
                systemSize: action.solar.systemSizeKw,
                productionRatio: action.solar.kwhPerKw,
                annualDeg: action.solar.annualDegredation,
                cashprice: action.solar.systemPrice,
                solarValue: action.solar.energyValue,
                installType: action.solar.installType,
                installType2: action.solar.installType2,
                solarPanel: action.solar.solarPanel,
                inverter: action.solar.inverter,
                systemNotes: action.solar.systemNotes,
            };

        case SET_SOLAR_SYSTEM_SIZE:
            return { ...state, systemSize: action.systemSize };

        case SET_SOLAR_PRODUCTION_RATIO:
            return { ...state, productionRatio: action.productionRatio };

        case SET_SOLAR_ANNUAL_DEG:
            return { ...state, annualDeg: action.annualDeg };

        case SET_SYSTEM_PRICE:
            return { ...state, cashprice: action.cashprice };

        case SET_SOLAR_VALUE:
            return { ...state, solarValue: action.solarValue };

        case SET_INSTALL_TYPE:
            return { ...state, installType: action.installType };

        case SET_INSTALL_TYPE2:
            return { ...state, installType2: action.installType2 };

        case SET_SOLAR_PANEL:
            return { ...state, solarPanel: action.solarPanel };

        case SET_INVERTER:
            return { ...state, inverter: action.inverter };
        case SET_SYSTEM_NOTES:
            return { ...state, systemNotes: action.systemNotes };

        default:
            return state;
    }
};

export default solar;



// WEBPACK FOOTER //
// ./src/containers/common/solar/reducer.js